import FinderViewBase from '../FinderViewBase/FinderViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ServiceBookingFinder.html?raw';
import on from 'dojo/on';
import Button from '../../moreCore/UI/Button/Button';
import "../../moreCore/UI/Button/Button";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import ServiceBookingEditor from '../ServiceBookingManagement/ServiceBookingEditor/ServiceBookingEditor';


class ServiceBookingFinder extends compose(FinderViewBase) {
    templateString: any = template;

    OpusfinderTableParams: tableParams = { widgetName: "ServiceBookingFinder", sContainerNodeName: "resultContainer" };

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern
    entityListAttributeName = "entitylist";
    loadFilterDatatUrl = "ServiceBookingManagement/GetServiceBookingList";
    loadFinderConfigUrl = "ServiceBookingManagement/GetFilterpanelOptions";
    btnContinueLabelText = (this as any).translations["AddressFinder_BtnSubmitNext"];
    btnSubmitLabelText = (this as any).translations["AddressFinder_BtnSubmit"];

   
    table_formatterFunction(cell: StaticTable.StaticTableCell<Entitylist>) {

        let colName = cell.name;
        let entity: Entitylist = <Entitylist>cell.entity;
        let node = cell.contentnode;
        switch (colName) { // Hier kann man auf die einzelnen Spalten jeder Reihe zugreifen und diese manuell formatieren / erweitern
            case "opusDetails":
                var btnCreateRequest = new Button();
                btnCreateRequest.setLabel(this.translations["OpusFinder_btn_showOpus"]);
                btnCreateRequest._onClick_Button = lang.hitch(this, this.showBookingDetails, entity);
                btnCreateRequest.setClasses("mds-gray mds-hover-dark w3-margin-right");
                btnCreateRequest.placeAt(node);
                return true;
                break;
                
            default:
                return false;
        }
    }

    showBookingDetails(row: StaticTable.StaticTableRow<any>, rowgroup: StaticTable.StaticTableRowGroup<any>) {
        console.log("details", row)
        let entity = row.rowGroup.entity;
        let dlg = new GenericDialog();

        let form = new ServiceBookingEditor();
        form.booking = entity;
        on(form, "saveComplete", lang.hitch(this, this._onOpusSaved, dlg));
        on(form, "dirty", lang.hitch(this, this._setDirtyClass, dlg));

        dlg.addButton("save", this.translations["TicketFinder_saveDataButton_label"], lang.hitch(form, form.saveOpus), null, null, "fas fa-save", false)

        //dlg.setUserdefinedButton(this.translations["TicketFinder_saveDataButton_label"], "fas fa-save", lang.hitch(form, form.saveOpus), false);

        dlg.enableContentOverflow(true);

        dlg.show('', entity['gDisp_opus'], null, null, "close", lang.hitch(this, this._onCloseDetailsDlg_Callback, dlg));
        dlg.addNodeToContent(form.domNode, "first");
        /*
        let list = new OpusAddressList();
        dlg.addNodeToContent(list.domNode, "last");
        */


        //form.setOpusEntityId(entity.ID);
        this._setDirtyClass(dlg, true);
        dlg.closeOnEnter = false;
        dlg.closeOnEscape = false;

    }

    _onClick_Submit(evt: Event) {
        if (this._isRequestActive === true || (this.getDirty() != true && this._completeList.length >= this.lastResponse.totalResultCount)) {
            return;
        }
        this.getFilterlist();
    }

    _onCloseDetailsDlg_Callback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, result: Number) {
        if (result == 99) { // Datensatz wurde gespeichert - neu laden!
            this.setDirty(true);
            this.getFilterlist();
        }
    }

    _onOpusSaved(dlg: MdsLax<InstanceType<typeof GenericDialog>>): void {
        dlg.close(99);
    }

    _setDirtyClass(dlg: MdsLax<InstanceType<typeof GenericDialog>>, isDirty: boolean) {
        let btn = dlg.getButtonByName("save");
        if (isDirty) {
            this.UiModder.domClass.remove(btn.node, 'w3-disabled');
        } else {
            this.UiModder.domClass.add(btn.node, 'w3-disabled');
        }
    }

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {
        if (this.OpusfinderTableParams) {

            // z.B. gleich eine Tabelle kreieren
            let tableLayoutOption = this.getFilterOptionByName("tableLayout");
            var selectedLayout: string = "default";
            let table = this.createTable(this.OpusfinderTableParams.widgetName,
                this[this.OpusfinderTableParams.sContainerNodeName],
                selectedLayout,
                this._completeList,
                lang.hitch(this, this.table_formatterFunction));
            table.setRowClick(lang.hitch(this, this.showBookingDetails))
        } else {
            alert("table params?");
        }
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setDocumentTitle("ServiceBooking");
    }
}

export default mdsWidget(ServiceBookingFinder);